angular.module('app.financeiro').factory('tempoDesembolsoFactory', ['$http', function ($http) {
    var _apiName = 'PropostaPagamentoAutomatico';

    var _obter = function (dataInicio, dataTermino) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/TempoDesembolso', dto);
    };

    var factory = {};

    factory.obter = _obter;

    return factory;
}]);